import styled from 'styled-components';
import { AvInput } from 'availity-mobx-reactstrap-validation';

export default styled(AvInput).attrs({ type: 'select' })`
  && {
    align-self: center;
    height: 2rem;
    line-height: 2rem;
    padding: 0;
    font-size: 0.8rem;
  }
`;
